var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.1C0 10.4051 0 7.55764 1.12587 5.39026C2.07462 3.56382 3.56382 2.07462 5.39026 1.12587C7.55764 0 10.4051 0 16.1 0H31.9C37.5949 0 40.4424 0 42.6097 1.12587C44.4362 2.07462 45.9254 3.56382 46.8741 5.39026C48 7.55764 48 10.4051 48 16.1V31.9C48 37.5949 48 40.4424 46.8741 42.6097C45.9254 44.4362 44.4362 45.9254 42.6097 46.8741C40.4424 48 37.5949 48 31.9 48H16.1C10.4051 48 7.55764 48 5.39026 46.8741C3.56382 45.9254 2.07462 44.4362 1.12587 42.6097C0 40.4424 0 37.5949 0 31.9V16.1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 16.1C0.25 13.2484 0.250201 11.1249 0.389876 9.443C0.529302 7.76409 0.806412 6.54756 1.34772 5.5055C2.27276 3.72473 3.72473 2.27276 5.5055 1.34772C6.54756 0.806412 7.76409 0.529302 9.443 0.389876C11.1249 0.250201 13.2484 0.25 16.1 0.25H31.9C34.7516 0.25 36.8751 0.250201 38.557 0.389876C40.2359 0.529302 41.4524 0.806412 42.4945 1.34772C44.2753 2.27276 45.7272 3.72473 46.6523 5.5055C47.1936 6.54756 47.4707 7.76409 47.6101 9.443C47.7498 11.1249 47.75 13.2484 47.75 16.1V31.9C47.75 34.7516 47.7498 36.8751 47.6101 38.557C47.4707 40.2359 47.1936 41.4524 46.6523 42.4945C45.7272 44.2753 44.2753 45.7272 42.4945 46.6523C41.4524 47.1936 40.2359 47.4707 38.557 47.6101C36.8751 47.7498 34.7516 47.75 31.9 47.75H16.1C13.2484 47.75 11.1249 47.7498 9.443 47.6101C7.76409 47.4707 6.54756 47.1936 5.5055 46.6523C3.72473 45.7272 2.27276 44.2753 1.34772 42.4945C0.806412 41.4524 0.529302 40.2359 0.389876 38.557C0.250201 36.8751 0.25 34.7516 0.25 31.9V16.1Z",
    stroke: "black",
    strokeOpacity: 0.15,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.32 24.3865C40.32 23.181 40.2118 22.0219 40.0109 20.9092H24V27.4851H33.1491C32.755 29.6101 31.5573 31.4106 29.7568 32.616V36.8815H35.2509C38.4654 33.9219 40.32 29.5637 40.32 24.3865Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 41.0001C28.59 41.0001 32.4382 39.4778 35.2509 36.8814L29.7568 32.616C28.2345 33.636 26.2873 34.2387 24 34.2387C19.5722 34.2387 15.8245 31.2482 14.4877 27.23H8.80814V31.6346C11.6054 37.1905 17.3545 41.0001 24 41.0001Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4877 27.2301C14.1477 26.2101 13.9545 25.1206 13.9545 24.0001C13.9545 22.8796 14.1477 21.7901 14.4877 20.7701V16.3655H8.80812C7.65676 18.6605 6.99994 21.2569 6.99994 24.0001C6.99994 26.7433 7.65676 29.3397 8.80812 31.6347L14.4877 27.2301Z",
    fill: "#FBBC05"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 13.7614C26.4959 13.7614 28.7368 14.6192 30.4986 16.3037L35.3745 11.4278C32.4304 8.68461 28.5823 7.00006 24 7.00006C17.3545 7.00006 11.6054 10.8096 8.80814 16.3655L14.4877 20.7701C15.8245 16.7519 19.5722 13.7614 24 13.7614Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.e7d049b4e9f4b1c9c9d072664139fbb6.svg";
export { ForwardRef as ReactComponent };